export const courses = [
	{
		platform: "codecademy",
		courses: [
			{
				title: "Web Development Foundations",
				sections: [
					"Full-Stack Engineering Path",
					"Fundamentals of HTML",
					"Fundamentals of CSS",
					"Developing Websites Locally",
					"Deploying Websites",
					"Improved Styling with CSS",
					"Making a Website Responsive",
				],
			},
			{
				title: "Building Interactive Websites",
				sections: [
					"JavaScript Syntax, Part I and II",
					"Git and GitHub, Part I",
					"Portfolio Project: JavaScript Syntax",
					"Building Interactive Websites",
					"Making a Website Accessible",
					"Portfolio Project: Personal Portfolio Website",
				],
			},
			{
				title: "Front-End Development",
				sections: [
					"JavaScript Syntax, Part III",
					"JavaScript Testing",
					"Async JavaScript and HTTP Requests",
					"Web Apps",
					"React",
					"Redux",
					"Portfolio Project: Reddit Client",
				],
			},
			{
				title: "Learn Advanced React",
				sections: [
					"Learn Advanced React",
					"Custom Hooks",
					"Context",
					"Error Boundaries",
					"Optimization",
				],
			},
			{
				title: "Learn React Testing",
				sections: ["Jest", "React Testing Library"],
			},
			{
				title: "Intro to Angular",
				sections: ["Angular Data Binding and Directives"],
			},
			{
				title: "Back-End Development",
				sections: [
					"Build a Back-end with Express.js",
					"User Authentication & Authorization",
					"Back-End and Feature Testing",
					"Database Basics",
					"Working with Databases",
					"Designing Relational Databases",
					"Advanced PostgreSQL",
					"API Development with Swagger and OpenAPI",
				],
			},
			{
				title: "Full-Stack Development",
				sections: [
					"Connecting Front-End to Back-End",
					"Deploying Web Applications",
					"Web Security Fundamentals",
					"Data Security",
					"Common Attacks on Web Applications",
					"Fundamentals of Operating Systems",
					"DevOps Fundamentals",
				],
			},
			{
				title: "Data Structures and Algorithms",
				sections: [
					"Linear Data Structures",
					"Complex Data Structures",
					"Algorithms",
					"Search & Graph Algorithms",
					"Interview Skills",
				],
			},
			{
				title: "Learn Java: Fundamentals, Intermediate, and Advanced",
				sections: [
					"Variables",
					"Object Oriented Programming",
					"Conditionals and Control Flow",
					"Arrays and Array Lists",
					"Loops",
					"String Methods",
					"Access, INcapsulation, and Static Methods",
					"Inheritance and Polymorphism",
					"Debugging",
					"Input and Output",
					"Serialization",
					"Generics and Collections",
					"Nested Classes",
					"Threading",
					"Regular Expressions",
					"Junit Testing",
					"Parallel and Concurrent Programming",
					"Servlets",
					"Sockets",
					"Java Native Interface",
					"JDBC",
				],
			},
			{
				title: "Create REST APIs with Spring and Java",
				sections: [
					"Web and Spring Basics",
					"Responding to Requests",
					"Spring Context",
					"Spring Controllers",
					"Data with JPA",
					"Boots and Beans",
					"Data Strategies",
				],
			},
			{ title: "Computer Science Career Path" },
			{
				title: "Build Web Apps with C# and ASP.NET",
				sections: [
					"Hello World",
					"Data Types and Variables",
					"Logic and Conditionals",
					"Methods",
					"Arrays and Loops",
					"Classes and Objects",
					"Interfaces and Inheritance",
					"References",
					"Lists and LINQ",
					"Web Architecture",
					"Make Your First ASP.NET App",
					"Razor Syntax",
					"Page Models",
					"Databases",
					"Middleware",
					"Dependency Injection",
				],
			},
			{
				title: "Learn C",
			},
			{
				title: "Learn Node.js",
			},
		],
	},
	{
		platform: "pluralsight",
		courses: [
			{
				title: "Angular Fundamentals",
				sections: [
					"Components",
					"Template Syntax",
					"Services",
					"HTTP Requests",
					"Routing",
					"Forms",
					"Pipes",
					"Directives",
					"Dependency Injection",
					"Testing",
					"State Management",
				],
			},
			{
				title: "App Dev Academy: Professional Scrum Master",
				sections: [
					"Scrum",
					"Scrum Events",
					"Scrum Artifacts",
					"Scrum Roles",
					"Product Backlog",
				],
			},
			{
				title: "Cloud Fundaments",
				sections: [
					"Cloud Foundations",
					"Core Azure Services",
					"Azure Pricing, SLA, and Lifecycle",
					"Azure Governance and Compliance",
					"Azure Security",
					"Azure Identity",
				],
			},
		],
	},
	{
		platform: "bootcamps",
		courses: [
			{
				title: "Year Up United: Application Development",
				instructors: "6 months of full-time training",
				sections: [
					"Python Basics",
					"Java",
					"Strings, Loops, Arrays, and Collections",
					"Advanced Object Oriented Programming",
					"Inheritance",
					"MySQL",
					"JDBC",
					"Rest APIs and Spring Boot",
				],
			},
		],
	},
	{
		platform: "udemy",
		courses: [
			{
				title: "50 Projects In 50 Days: HTML, CSS, & JavaScript",
				instructors: "Brad Traversy and Florin Pop",
			},
			{
				title: "Modern JavaScript From the Beginning",
				instructors: "Brad Traversy",
			},
			{
				title: "The Complete JavaScript Course 2023: From Zero to Hero",
				instructors: "Jonas Schmedtmann",
			},
			{
				title: "Modern React with Redux ",
				instructors: "Stephen Grider",
			},
			{
				title: "Modern React Bootcamp(Hooks, Context, NextJS, Router)",
				instructors: "Colt Steele",
			},
			{
				title: "React Front to Back",
				instructors: "Brad Traversy",
			},
			{
				title: "MERN Stack Front To Back: Full Stack React, Redux, & Node.js",
				instructors: "Brad Traversy",
			},
			{
				title: "The Complete Developer's Guide to MongoDB",
				instructors: "Stephen Grider",
			},
			{
				title: "C Programming: Becoming A Pro! Think Like a Programmer! ",
				instructors: "Ali Badran",
			},
			{
				title: "C Programming For Beginners – Master the C Language ",
				instructors: "Jason Fedin",
			},
			{
				title: "C Programming Bootcamp: The Complete C Language Course",
				instructors: "Vlad Budnitski",
			},
		],
	},
	{
		platform: "freeCodeCamp",
		courses: [
			{
				title: "Responsive Web Design",
				sections: [
					"Basic HTML and HTML5",
					"Basic CSS",
					"Applied Visual Design",
					"Applied Accessibility",
					"Responsive Web Design Principles",
					"CSS Flexbox",
					"CSS Grid",
					"Responsive Web Design Projects",
				],
			},
			{
				title: "JavaScript Algorithms and Data Structures",
				sections: [
					"ES6",
					"Regular Expressions",
					"Debugging",
					"Basic Data Structures",
					"Basic Algorithm Scripting",
					"Object Oriented Programming",
					"Functional Programming",
					"Intermediate Algorithm Scripting",
					"JavaScript Algorithms and Data Structure Projects",
				],
			},
		],
	},
	{
		platform: "books",
		courses: [
			{
				title: "HTML & CSS: design and build websites",
				author: "Jon Duckett",
			},
			{
				title: "JavaScript & JQuery:  Interactive Front-end Web Development",
				author: "Jon Duckett",
			},
			{
				title: "Eloquent Javascript: A Modern Introduction to Programming",
				author: "Marijn Haverbeke",
			},
			{
				title: "Grokking Algorithms",
				author: "Adita Y. Bhargava",
			},
			{
				title:
					"Cracking the Coding Interview: 189 Programming Questions and Solutions",
				author: "Gayle Laakmann McDowell",
			},
		],
	},
];
